import React, { useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { Button, Box, Typography, Alert, CircularProgress } from '@mui/material';
import { payForPrediction, setError as setTradingError } from '../../store/Slices/aiTradingSlice';
import { fetchAIBalances } from '../../store/Slices/assetSlice';

const PredictionPaymentForm = () => {
  const dispatch = useDispatch();
  const user = useSelector((state) => state.user.data);
  const { loading: tradeLoading, error: tradingError } = useSelector((state) => state.aiTrading);
  const { light } = useSelector((state) => state.theme);
  const [localError, setLocalError] = useState('');

  const handlePayForPrediction = async () => {
    console.log('Initiating payment for prediction');
    setLocalError('');
    dispatch(setTradingError(null));

    if (!user?.ai_wallet) {
      setLocalError('AI wallet not configured. Please contact support.');
      return;
    }

    try {
      const paymentAction = await dispatch(
        payForPrediction({
          user_id: user._id,
          ai_wallet_id: user.ai_wallet,
        })
      );

      if (paymentAction.meta.requestStatus === 'fulfilled') {
        console.log('Payment successful, scheduling balance refresh');
        setTimeout(async () => {
          console.log('Refreshing AI balances');
          const balanceAction = await dispatch(fetchAIBalances());
          console.log('Balance refresh response:', balanceAction.payload);
        }, 500);
      } else {
        setLocalError('Failed to process payment. Please try again.');
        console.error('Payment failed:', paymentAction.payload);
      }
    } catch (err) {
      setLocalError('Error processing payment. Please try again.');
      console.error('Payment error:', err);
    }
  };

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        gap: 2,
        p: 3,
        bgcolor: light ? '#fff' : '#2c2c2c',
        borderRadius: 1,
        boxShadow: '0 4px 6px rgba(0,0,0,0.1)',
      }}
    >
      <Typography variant="h6" sx={{ mb: 2, fontWeight: 'medium', color: light ? '#1a1a1a' : '#fff' }}>
        Unlock Price Prediction
      </Typography>
      <Typography variant="body1" sx={{ color: light ? 'text.secondary' : '#b0b0b0' }}>
        Pay 1 USDT to view the 4-hour price prediction and chart for BTC/USDT.
      </Typography>
      {(tradingError || localError) && <Alert severity="error">{tradingError || localError}</Alert>}
      <Button
        variant="outlined"
        sx={{
          borderColor: '#F3BA2F',
          color: '#F3BA2F',
          py: 1.5,
          fontWeight: 'medium',
          transition: 'all 0.3s',
          '&:hover': { bgcolor: '#F3BA2F', color: '#fff' },
          width: { xs: '100%', sm: 'auto' },
        }}
        onClick={handlePayForPrediction}
        disabled={tradeLoading || !user?.ai_wallet}
      >
        {tradeLoading ? <CircularProgress size={24} color="inherit" /> : 'Pay 1 USDT'}
      </Button>
    </Box>
  );
};

export default PredictionPaymentForm;